import React from 'react'
import { RTCInitialState, RTCReducer } from './RTCReducer'

const RTCStateContext = React.createContext()
const RTCDispatchContext = React.createContext()

function RTCProvider({ children }) {
  const [state, dispatch] = React.useReducer(RTCReducer, RTCInitialState)
  return (
    <RTCStateContext.Provider value={state}>
      <RTCDispatchContext.Provider value={dispatch}>{children}</RTCDispatchContext.Provider>
    </RTCStateContext.Provider>
  )
}

function useRTCState() {
  const context = React.useContext(RTCStateContext)
  if (context === undefined) {
    throw new Error('ERROR: useRTCState must be used inside of RTCProvider')
  }
  return context
}

function useRTCDispatch() {
  const context = React.useContext(RTCDispatchContext)
  if (context === undefined) {
    throw new Error('ERROR: useRTCDispatch must be used inside of RTCProvider')
  }
  return context
}

export { RTCProvider, useRTCState, useRTCDispatch }
